import { render, staticRenderFns } from "./CardModalActivityItem.vue?vue&type=template&id=5d05f910&scoped=true"
import script from "./CardModalActivityItem.vue?vue&type=script&lang=js"
export * from "./CardModalActivityItem.vue?vue&type=script&lang=js"
import style0 from "./CardModalActivityItem.vue?vue&type=style&index=0&id=5d05f910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05f910",
  null
  
)

export default component.exports